import { getCurrentLocation, clearLocationCache } from "./location_utils";
import { i18n } from "../lib/i18n";

interface LocationButtonOptions {
  onLocationUpdate?: (position: google.maps.LatLngLiteral) => void;
  map: google.maps.Map;
}

export function addCurrentLocationButton({
  map,
  onLocationUpdate,
}: LocationButtonOptions): HTMLButtonElement {
  const locationButton = document.createElement("button");
  locationButton.classList.add("map-control", "location-button");
  locationButton.title = i18n.t('map_controls.current_location');

  // Add location SVG icon using the image file
  const img = document.createElement("img");
  img.src = "/location.svg";
  img.alt = i18n.t('map_controls.current_location');
  locationButton.appendChild(img);

  // Add styles
  const style = document.createElement("style");
  style.textContent = `
    .map-control.location-button {
      background-color: #4285F4;
      border: none;
      border-radius: 50%;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      cursor: pointer;
      margin: 10px;
      padding: 0;
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.2s ease;
    }
    .map-control.location-button:hover {
      background-color: #1A73E8;
    }
    .map-control.location-button img {
      width: 18px;
      height: 18px;
      filter: brightness(0) invert(1);
    }
  `;
  document.head.appendChild(style);

  // Add click handler
  locationButton.addEventListener("click", async () => {
    try {
      clearLocationCache();
      const location = await getCurrentLocation();
      const position = {
        lat: location.latitude,
        lng: location.longitude,
      };

      map.setCenter(position);
      map.setZoom(15);

      if (onLocationUpdate) {
        onLocationUpdate(position);
      }
    } catch (error) {
      console.error("Error getting location:", error);
    }
  });

  // Add button to map
  map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(locationButton);

  return locationButton;
}

